"use client";

import axios from "axios";
import { createContext, PropsWithChildren, useContext, useEffect, useMemo } from "react";
import { webEnv } from "@/environment/environment";
import { getServerSession, Session } from "next-auth";
import { useSession } from "next-auth/react";
import { NextAuthConfig } from "@/auth";

const axiosInstance = axios.create({
  baseURL: webEnv.api.url, // Set your API base URL
});

const AxiosContext = createContext(axiosInstance);
export function useAxios() {
  return useContext(AxiosContext);
}

export default function AxiosProvider({ children, session }: PropsWithChildren & { session: Session | null }) {
  const { data, update, status } = useSession();
  const s = useMemo(() => {
    return data ?? session;
  }, [data, session]);
  useEffect(() => {
    axiosInstance.interceptors.request.use(async (config) => {
      if (s) {
        config.headers["Authorization"] = `Bearer ${s.token}`;
      } else {
        delete config.headers["Authorization"];
      }

      return config;
    });
  }, [s]);

  return <AxiosContext.Provider value={axiosInstance}>{children}</AxiosContext.Provider>;
}
